<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre2" id="calibre_pb_0"></div>
<p class="p_norm-center__and__page_break" id="auto_bookmark_toc_1"><span>To Naomi, for her boundless enthusiasm for this story. You made writing it a joy.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?38831f05